<template>
  <div>
    <tr
      class="ivu-table-row"
    >
      <td
        :style="[{
          backgroundColor: column.columnBackgroundColor || '',
          width: `${width}px`,
          minWidth: `${width}px`,
          maxWidth: `${width}px`,
          whiteSpace: 'pre',
          textAlign: 'left',
          paddingLeft: '5px'
        }, column.styles]"
        class="ivu-table-column-center"
      >
        <div
          :style="{ marginLeft: `${path.length * indentSize}px`}"
          class="ivu-table-cell-tree-level"
        />
        <div
          v-if="column.children"
          class="ivu-table-cell-tree"
          @click.prevent.stop="handleToggleTree"
        >
          <div v-if="!column._childrenExpand">
            &#43;
          </div>
          <div v-else>
            &#8722;
          </div>
        </div>
        {{ column.displayName || column.name }}
        <Tooltip
          v-if="column.info"
          :content="column.info"
          transfer
          max-width="200"
        >
          <i class="fas fa-info-circle" />
        </Tooltip>
      </td>
    </tr>
    <template v-if="column.children">
      <CustomTableTrFixedColumn
        v-for="(childrenColumn, index) in Object.keys(column.children)"
        v-show="column._childrenExpand"
        :key="`custom-table-body-tr-${index}`"
        :column="Object.assign(column.children[childrenColumn], { name: childrenColumn })"
        :width="width"
        :indent-size="indentSize"
        :path="[...path, column.name, 'children']"
      />
    </template>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  // TODO: rewrite this function using render
  name: 'CustomTableTrFixedColumn',

  inject: ['tableColumns'],

  props: {
    column: {
      type: Object,
      default: () => {}
    },
    width: {
      type: Number,
      default: 30
    },
    path: {
      type: Array,
      default: () => []
    },
    indentSize: {
      type: Number,
      default: 10
    }
  },

  methods: {
    /**
     * Handle user event to expand/collapse children nodes by setting boolean value
     * from root table object
     */
    handleToggleTree () {
      const column = _.get(this.tableColumns, [...this.path, this.column.name])
      this.$set(column, '_childrenExpand', !(column._childrenExpand || false))
    }
  }
}
</script>

<style scoped>
  .ivu-table-small td {
    height: 30px;
  }
</style>
